import React, { useState, useRef, useEffect } from 'react';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import MinimizeIcon from '@material-ui/icons/Minimize';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';

import Control from '../../pages/store/control';

const DraggableWindow = ({ children, initialPosition }) => {
  const [position, setPosition] = useState(initialPosition);
  const [isDragging, setIsDragging] = useState(false);
  const [isMinimized, setIsMinimized] = useState(false);
  const [isTypographyVisible, setIsTypographyVisible] = useState(true);
  const windowRef = useRef(null);
  const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });

  const explanationText = Control.Get('explanationText');
  const explanationImg = Control.Get('explanationImg');

  const handleMouseDown = (event) => {
    setIsDragging(true);
    windowRef.current.style.cursor = 'grabbing';
    setDragOffset({
      x: event.clientX - position.x,
      y: event.clientY - position.y,
    });
  };

  const handleMouseMove = (event) => {
    if (isDragging) {
      setPosition({
        x: event.clientX - dragOffset.x,
        y: event.clientY - dragOffset.y,
      });
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);
    windowRef.current.style.cursor = 'grab';
  };

  const toggleMinimize = () => {
    setIsMinimized(!isMinimized);
    setIsTypographyVisible(!isTypographyVisible);
  };

  useEffect(() => {
    if (isDragging) {
      window.addEventListener('mousemove', handleMouseMove);
      window.addEventListener('mouseup', handleMouseUp);
    } else {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    }

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isDragging]);

  return (
    <Paper
      ref={windowRef}
      style={{
        position: 'fixed',
        top: position.y,
        left: position.x,
        padding: '10px',
        cursor: 'grab',
        zIndex: 5000,
        backgroundColor: 'rgb(24, 28, 32)',
        width: isMinimized ? '200px' : `${window.innerWidth * 0.2}px`, // Updated width
        height: isMinimized ? '50px' : 'auto',
      }}
      onMouseDown={handleMouseDown}
    >
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <IconButton
          style={{ color: 'white' }}
          onClick={toggleMinimize}
        >
          {isMinimized ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
        <Typography variant="body1" style={{ color: 'white', marginLeft: '8px', fontSize: '0.875rem'}}>Explanation</Typography>
      </div>
      {!isMinimized && children}

      {isTypographyVisible && (
        <>
          <Typography variant="body1" style={{ color: 'rgb(139, 141, 143)', fontSize: '0.875rem'}} dangerouslySetInnerHTML={{ __html: explanationText }} />
          {explanationImg && (
            <img src={`${explanationImg}`} alt="Explanation" style={{ width: '100%', marginTop: '10px' }} />
          )}
        </>
      )}
    </Paper>
  );
};

export default DraggableWindow;